import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { IDepreciationMethodDto } from '~/models/modules/Asset/depreciationMethod';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class DepreciationMethodService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }

  getDepreciationMethodById(id: number) {
    return this.client.get<IDepreciationMethodDto>(this._url(`/${id}`))
  }

  getDepreciationMethodListing() {
    return this.http.get<IDepreciationMethodDto[]>(this._url());
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/DepreciationMethod${v}`);
  }
}
